import React from "react";
import Flex from "../Flex";
import * as SC from "./OverlapLogos.styles";

interface OverlapLogosProps {
  topImage: string;
  backImage: string;
}

export const OverlapLogos = ({ topImage, backImage }: OverlapLogosProps) => {
  return (
    <SC.OverlapLogosContainer>
      <Flex align="center" justify="center" width="100%">
        <SC.TopImage src={topImage} alt="Top Image Logo" />
        <img src={backImage} alt="Back Image Logo" />
      </Flex>
    </SC.OverlapLogosContainer>
  );
};
